<template>
    <button class="button button--reset js-accordion-heading show-more__heading" aria-expanded="false" aria-selected="false" tabindex="0" role="tab">
        <span class="show-more__heading-text">
            {{ prefix }}
            <span v-bind:class="{ activeMult: more }" class="show-more__heading-more">mult</span>
            <span v-bind:class="{ activePutin: more }" class="show-more__heading-less">puțin</span>
        </span>
        <span v-bind:class="{ activeMult: more }" class="show-more__heading-chevron">
            <svg focusable="false" aria-hidden="true" class="icon icon--small">
                <use xlink:href="#icon-chevron-down"></use>
            </svg>
        </span>
        <span v-bind:class="{ activePutin: more }" class="show-more__heading-chevron hideit">
            <svg focusable="false" aria-hidden="true" class="icon icon--small">
                <use xlink:href="#icon-chevron-up"></use>
            </svg>
        </span>
    </button>
</template>

<script>
export default {
    name: 'ButtonMore',
    props: ['prefix', 'more'],
};
</script>
